var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9287 4.99414C13.8909 3.32748 16.2966 3.32747 17.2588 4.99414L24.4069 17.375C25.3692 19.0417 24.1663 21.125 22.2418 21.125H7.94566C6.02116 21.125 4.81834 19.0417 5.78059 17.375L12.9287 4.99414Z",
    stroke: "#AD0C0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6497 8.87351L15.4677 15.6635H14.1377L13.9557 8.87351H15.6497ZM14.8517 18.7015C14.5623 18.7015 14.3197 18.6035 14.1237 18.4075C13.9277 18.2115 13.8297 17.9688 13.8297 17.6795C13.8297 17.3902 13.9277 17.1475 14.1237 16.9515C14.3197 16.7555 14.5623 16.6575 14.8517 16.6575C15.1317 16.6575 15.3697 16.7555 15.5657 16.9515C15.7617 17.1475 15.8597 17.3902 15.8597 17.6795C15.8597 17.9688 15.7617 18.2115 15.5657 18.4075C15.3697 18.6035 15.1317 18.7015 14.8517 18.7015Z",
    fill: "#E30606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningPoi);
export default __webpack_public_path__ + "static/media/WarningPOI.01450347bdd43795149d80365a01faa9.svg";
export { ForwardRef as ReactComponent };